<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <form (submit)="onSubmit()" class="m-4" *ngIf="eventType !== null">

      <div class="form-group">
        <label for="waitlist_scope">
          Waitlist Scope
        </label>
        <div class="row">
          <div class="col-md-8 col-xl-6">
            <select id="waitlist_scope"
                    name="waitlist_scope"
                    class="custom-select"
                    [disabled]="eventType?.schedule_type === ScheduleType.rolling"
                    [class.disabled]="eventType?.schedule_type === ScheduleType.rolling"
                    [ngbTooltip]="(eventType?.schedule_type === ScheduleType.rolling) ? 'Rolling event types are required to have event type-wide waitlists.' : ''"
                    [(ngModel)]="eventType.waitlist_scope"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="EventTypeWaitlistScope.event">Specific to each event</option>
              <option [ngValue]="EventTypeWaitlistScope.eventType">Shared across event type</option>
            </select>
          </div>
        </div>
        <div class="form-text text-danger">{{ eventTypeErrors.waitlist_scope }}</div>
        <small class="form-text text-muted">
          If this is set to "Shared across event type", then all events of this type will share a single waitlist.
        </small>
        <div class="alert alert-warning mt-2" *ngIf="initialWaitlistScope !== eventType.waitlist_scope">
          If the event type's waitlist scope is changed, all customers currently on the waitlist with status "Waiting" will be removed.
        </div>
      </div>

      <ng-container *ngIf="eventType.waitlist_scope === EventTypeWaitlistScope.event">

        <div class="form-group">
          <label for="allowCustomersToJoinWaitlistSelect">
            Can customers join the waitlist via the Climber App when the event is at capacity?
          </label>
          <div class="row">
            <div class="col-md-8 col-xl-6">
              <select id="allowCustomersToJoinWaitlistSelect"
                      name="allowCustomersToJoinWaitlistSelect"
                      class="custom-select"
                      [(ngModel)]="eventType.allow_customers_to_join_waitlist"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>
          <div class="form-text text-danger">{{ eventTypeErrors.allow_customers_to_join_waitlist }}</div>
          <small class="form-text text-muted">
            If this is set to "No", then the event's waitlist may only be managed via the Staff Site Scheduled Events page.
          </small>
        </div>

        <div *ngIf="eventType.allow_customers_to_join_waitlist"
             class="pl-2" style="border-left: 2px solid lightgray">
          <div class="form-group">
            <label for="displayWaitlistCountInClimberAppSelect">
              Should the waitlist count be displayed in the Climber App?
            </label>
            <div class="row">
              <div class="col-md-8 col-xl-6">
                <select id="displayWaitlistCountInClimberAppSelect"
                        name="displayWaitlistCountInClimberAppSelect"
                        class="custom-select"
                        [(ngModel)]="eventType.display_waitlist_count_in_climber_app"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>
              </div>
            </div>
            <div class="form-text text-danger">{{ eventTypeErrors.display_waitlist_count_in_climber_app }}</div>
            <small class="form-text text-muted">
              If this is set to "Yes", then customers using the Climber App will be shown number of participants already on the waitlist for the event. The waitlist count is always shown on the Staff Site.
            </small>
          </div>
        </div>

        <div class="form-group">
          <label for="automaticallyInviteOffWaitlistSelect">
            Should people be automatically invited off the waitlist when capacity becomes available?
          </label>
          <div class="row">
            <div class="col-md-8 col-xl-6">
              <select id="automaticallyInviteOffWaitlistSelect"
                      name="automaticallyInviteOffWaitlistSelect"
                      class="custom-select"
                      [(ngModel)]="eventType.automatically_invite_off_waitlist"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>
          <div class="form-text text-danger">{{ eventTypeErrors.automatically_invite_off_waitlist }}</div>
          <small class="form-text text-muted">
            If this is set to "No", then customers must be invited off the waitlist manually by staff.
          </small>
        </div>

        <div *ngIf="eventType.automatically_invite_off_waitlist"
             class="pl-2" style="border-left: 2px solid lightgray">
          <div class="form-group">
            <label for="minHoursBeforeEventForAutomaticWaitlistInvite">
              Minimum number of hours before event start for automatic waitlist invite
            </label>
            <div class="row">
              <div class="col-md-8 col-xl-6">
                <input id="minHoursBeforeEventForAutomaticWaitlistInvite"
                       name="minHoursBeforeEventForAutomaticWaitlistInvite"
                       class="form-control"
                       type="number" min="0" step="0" required
                       [(ngModel)]="eventType.min_hours_before_event_for_automatic_waitlist_invite"
                       (ngModelChange)="unsavedChanges = true">
              </div>
            </div>
            <div class="form-text text-danger">{{ eventTypeErrors.min_hours_before_event_for_automatic_waitlist_invite }}</div>
            <small class="form-text text-muted">
              This sets the time after which no further automatic invites will occur. Setting this to a nonzero value ensures customers are given sufficient notice prior to the event starting.
              <br>
              Customers may always be manually invited off the waitlist by staff members via the Scheduled Events page, regardless of this setting.
            </small>
          </div>
        </div>

      </ng-container>

      <ng-container *ngIf="eventType.waitlist_scope === EventTypeWaitlistScope.eventType">

        <div class="form-group">
          <label for="allowCustomersToJoinWaitlistEventTypeScopeSelect">
            Can customers join the waitlist via the Climber App?
          </label>
          <div class="row">
            <div class="col-md-8 col-xl-6">
              <select id="allowCustomersToJoinWaitlistEventTypeScopeSelect"
                      name="allowCustomersToJoinWaitlistEventTypeScopeSelect"
                      class="custom-select"
                      [(ngModel)]="eventType.allow_customers_to_join_waitlist"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>
          <div class="form-text text-danger">{{ eventTypeErrors.allow_customers_to_join_waitlist }}</div>
          <small class="form-text text-muted">
            If this is set to "No", then the event's waitlist may only be managed via the Staff Site.
          </small>
        </div>

        <div class="form-group">
          <label for="allow_waitlist_customers_to_select_preferred_days_of_week">
            Should customers indicate their preferred days of the week when joining the waitlist?
          </label>
          <div class="row">
            <div class="col-md-8 col-xl-6">
              <select id="allow_waitlist_customers_to_select_preferred_days_of_week"
                      name="allow_waitlist_customers_to_select_preferred_days_of_week"
                      class="custom-select"
                      [(ngModel)]="eventType.allow_waitlist_customers_to_select_preferred_days_of_week"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>
          <div class="form-text text-danger">{{ eventTypeErrors.allow_waitlist_customers_to_select_preferred_days_of_week }}</div>
          <small class="form-text text-muted">
            If "Yes", customers joining the waitlist will be prompted to choose which day or days of the week they prefer.
          </small>
        </div>

        <div class="form-group">
          <label for="allow_waitlist_customers_to_select_preferred_locations">
            Should customers indicate their preferred locations when joining the waitlist?
          </label>
          <div class="row">
            <div class="col-md-8 col-xl-6">
              <select id="allow_waitlist_customers_to_select_preferred_locations"
                      name="allow_waitlist_customers_to_select_preferred_locations"
                      class="custom-select"
                      [(ngModel)]="eventType.allow_waitlist_customers_to_select_preferred_locations"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>
          <div class="form-text text-danger">{{ eventTypeErrors.allow_waitlist_customers_to_select_preferred_locations }}</div>
          <small class="form-text text-muted">
            If "Yes", customers joining the waitlist will be prompted to choose which location or locations they prefer.
          </small>
        </div>

      </ng-container>

      <div class="form-group">
        <label for="hoursToAcceptWaitlistSpotInput">
          How many hours does a waitlisted participant have to accept the spot once offered? (optional)
        </label>
        <div class="row">
          <div class="col-md-8 col-xl-6">
            <input id="hoursToAcceptWaitlistSpotInput"
                   name="hoursToAcceptWaitlistSpotInput"
                   class="form-control"
                   type="number" min="1" step="1"
                   [(ngModel)]="eventType.hours_to_accept_waitlist_spot"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <div class="form-text text-danger">{{ eventTypeErrors.hours_to_accept_waitlist_spot }}</div>
        <small class="form-text text-muted">
          This sets how many hours a waitlisted participant has to accept and pay (when applicable) for the event once a spot is offered to them. If left blank, the spot will be held for the participant indefinitely unless manually expired by staff.
        </small>
      </div>

      <div class="form-group"
           *ngIf="eventType?.schedule_type === ScheduleType.rolling">
        <label for="require_payment_method_to_join_waitlist">
          Are customers required to provide a payment method when joining the waitlist?
        </label>
        <div class="row">
          <div class="col-md-8 col-xl-6">
            <select id="require_payment_method_to_join_waitlist"
                    name="require_payment_method_to_join_waitlist"
                    class="custom-select"
                    [(ngModel)]="eventType.require_payment_method_to_join_waitlist"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </div>
        <div class="form-text text-danger">{{ eventTypeErrors.require_payment_method_to_join_waitlist }}</div>
        <small class="form-text text-muted">
          The payment method will not be charged until the customer joins a roster.
        </small>
      </div>

      <div class="form-group"
           *ngIf="eventType?.schedule_type === ScheduleType.rolling">
        <label for="require_membership_ts_and_cs_to_join_waitlist">
          Are customers required to agree to the roster membership terms and conditions when joining the waitlist?
        </label>
        <div class="row">
          <div class="col-md-8 col-xl-6">
            <select id="require_membership_ts_and_cs_to_join_waitlist"
                    name="require_membership_ts_and_cs_to_join_waitlist"
                    class="custom-select"
                    [(ngModel)]="eventType.require_membership_ts_and_cs_to_join_waitlist"
                    (ngModelChange)="unsavedChanges = true">
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </div>
        <div class="form-text text-danger">{{ eventTypeErrors.require_membership_ts_and_cs_to_join_waitlist }}</div>
      </div>

      <div class="form-group">
        <label>Waitlist Confirmation Email Text</label>
        <app-markdown-editor [(content)]="eventType.waitlist_confirmation_email_text"
                             (change)="unsavedChanges = true"
                             [id]="'waitlistConfirmationEmailText'"
                             [shortEditor]="true">
        </app-markdown-editor>
        <small class="form-text text-muted">
          This will be included on the email to the booking customer confirming their spot on the waitlist.
        </small>
        <div class="form-text text-danger">{{ eventTypeErrors.waitlist_confirmation_email_text }}</div>
        <div class="mt-2">
          <button type="button" class="btn btn-outline-primary btn-sm"
                  (click)="openWaitlistConfirmationEmailPreviewModal()">
            Preview Email
          </button>
        </div>
      </div>

      <div class="form-group"
           *ngIf="eventType?.schedule_type === ScheduleType.rolling">
        <label for="staffNotificationEmailAddressesInput">
          Waitlist Staff Notification Email Addresses (optional)
        </label>
        <div class="row">
          <div class="col-md-8 col-xl-6">
            <input type="text" class="form-control"
                   id="staffNotificationEmailAddressesInput" name="staff_notification_email_addresses"
                   [(ngModel)]="eventType.waitlist_staff_notification_email_addresses"
                   (ngModelChange)="unsavedChanges = true">
          </div>
        </div>
        <small class="form-text text-muted">
          Provide one or more email addresses, separated by commas. These email addresses will receive a notification whenever a customer is added to the waitlist for this event type.
        </small>
        <div class="form-text text-danger">
          {{ eventTypeErrors.waitlist_staff_notification_email_addresses }}
        </div>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="eventTypeErrors.non_field_errors">
        {{ eventTypeErrors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="eventTypeErrorMessage">
        {{ eventTypeErrorMessage }}
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingEventType">
        Loading...
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="isLoading()" [class.disabled]="isLoading()">
          Save
        </button>
      </div>
      <button [routerLink]="['/events/setup/event-types']"
              [queryParams]="{status: eventType?.status}"
              class="btn btn-secondary"
              [disabled]="isLoading()" [class.disabled]="isLoading()">
        Back
      </button>

    </form>

  </div>

</div>
